import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
// import { setPageTitle } from '../../store/actions.js'
import "./index.css"


class Belt extends Component {

    render() {
        return (
            <div>
                <div id="ban-content" className="ban-conter" >
                    <div className="world_box">
                        <div className="world"><h1>念两句诗</h1></div>
                        <div>
                        <p id="poem">无边落木萧萧下，不尽长江滚滚来。</p>
                        <p id="info">【唐代】杜甫《登高》</p>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}



export default connect()(Belt)